const notifyErrorDefaults = {
    title: 'Error',
    width: '50%',
    type: 'error',
    duration: 5000
}

export default notifyErrorDefaults;